import { getProductTier } from '../../../utils/getProductTier';
import isQA from '../../../utils/isQA';
import loadScript from '../../../utils/loadScript';
export function getHelpConfig(scopes, displayLanguage) {
  let help015 = 'control';
  let help030 = 'control';
  let help040 = 'control';
  let help044 = 'control';
  let help063 = 'control';
  const isEnglish = displayLanguage && displayLanguage.includes('en');
  const productTier = getProductTier(scopes);
  const isStarter = productTier === 'starter';
  const isFree = productTier === 'free';
  const isPro = productTier === 'pro';
  const isEnterprise = productTier === 'enterprise';
  if (isStarter) {
    help015 = 'variant1';
  }
  if (isFree) {
    help030 = 'variant1';
  }
  if (isPro && isEnglish) {
    help040 = 'variant';
  }
  if (isEnterprise && isEnglish) {
    help044 = 'variant';
  }
  if ((isEnterprise || isPro) && !isEnglish) {
    help063 = 'variant';
  }
  const isHelpShownInToolbar = help015 === 'variant1' || help030 === 'variant1' || help040 === 'variant' || help044 === 'variant' || help063 === 'variant';
  return {
    help015,
    help030,
    help040,
    help044,
    help063,
    isHelpShownInToolbar
  };
}
export function getZorseScriptUrl() {
  try {
    const isLocal = window.localStorage && window.localStorage.NAVIGATION_ZORSE_ASSET_ENV === 'local';
    if (isLocal && window.hubspot && window.hubspot.zorse) {
      // Setting this to true will enable the Zorse dev mode, which will load the Zorse scripts from local.hsappstatic.net
      // https://git.hubteam.com/HubSpot/HelpButtonUI/blob/master/static/js/button_loader.js#L63
      window.hubspot.zorse.dev = true;
    }
    const isHelpLocalDev = window.location.href.match('local-in-app-help-ui=true');
    if (isHelpLocalDev && window.hubspot && window.hubspot.zorse) {
      window.hubspot.zorse.isHelpLocalDev = true;
    }
    if (isHelpLocalDev) {
      // return the local path to the Zorse button loader script when 'local-in-app-help-ui=true' is present in the URL
      return `//local.hsappstatic.net/HelpButtonUI/static/js/button_loader.js`;
    }
  } catch (err) {
    // no-op, fail silently
  }
  return getLivePathUrl('//static.hsappstatic.net/HelpButtonUI/ex/coffee/button_injector');
  function getLivePathUrl(scriptBasePath) {
    return `${scriptBasePath}${isQA() ? '-qa' : ''}.js`;
  }
}
export function shouldShowZorse() {
  const zorse = window.hubspot.zorse;
  if (!zorse) {
    return true;
  }
  const {
    shouldUseNavComponents,
    supressed,
    isHelpInTheNav
  } = zorse;
  return Boolean(!shouldUseNavComponents && (!supressed || isHelpInTheNav));
}
export function loadZorse(onLoadCb) {
  window.hubspot = window.hubspot || {};
  window.hubspot.zorseScriptURL = getZorseScriptUrl();
  const ZORSE_SCRIPT_EXECUTION_TIMEOUT = 10;
  const curriedOnloadCb = () => {
    if (!onLoadCb) {
      return;
    }
    const hubspot = window.hubspot;
    const loadZorseTimeoutId = setTimeout(() => {
      clearTimeout(loadZorseTimeoutId);
      if (!hubspot.zorse || !hubspot.zorse.openHelpWidget) {
        curriedOnloadCb();
      } else {
        onLoadCb();
      }
    }, ZORSE_SCRIPT_EXECUTION_TIMEOUT);
  };
  loadScript(getZorseScriptUrl(), {
    onload: curriedOnloadCb
  });
}
const setHelpExperimentFlag = (windowRef, {
  help015,
  help030,
  help040,
  help044,
  help063
}) => {
  windowRef.hubspot.zorse.help015 = help015;
  windowRef.hubspot.zorse.help020 = help030; // Reusing Help020 logic for the Non-English rollout
  windowRef.hubspot.zorse.help040 = help040;
  windowRef.hubspot.zorse.help044 = help044;
  windowRef.hubspot.zorse.help063 = help063;
};
const initializeWindowRef = windowRef => {
  windowRef.hubspot = windowRef.hubspot || {
    zorse: {}
  };
  windowRef.hubspot.zorse = windowRef.hubspot.zorse || {};
  windowRef.hubspot.zorseScriptURL = getZorseScriptUrl();
};
export const addHelpParamsToWindow = (helpExperimentFlags, isHelpShownInToolbar) => {
  const windowRef = window;
  initializeWindowRef(window);
  setHelpExperimentFlag(windowRef, helpExperimentFlags);
  windowRef.hubspot.zorse.isHelpInTheNav = isHelpShownInToolbar;
  windowRef.hubspot.zorse.shouldUseNavComponents = true;
};
export const addAcademyHelpParamsToWindow = helpExperimentFlags => {
  const windowRef = window;
  initializeWindowRef(windowRef);
  setHelpExperimentFlag(windowRef, helpExperimentFlags);

  // as the academy page does not have the global toolbar, we fallback to use Zorse button instead
  windowRef.hubspot.zorse.isHelpInTheNav = false;
  windowRef.hubspot.zorse.shouldUseNavComponents = false;
};